<template>
  <div>
    <cabecera></cabecera>
    <menuLateral></menuLateral>
    <router-view/>
    <pie></pie>
  </div>
</template>

<script>

import cabecera from '../components/cabecera.vue'
import cesiumViewer from '../components/cesiumViewer.vue'
import menuLateral from '../components/menuLateral.vue'
import pie from '../components/pie.vue'


export default {
  name: 'aplicacion',
  components: {
    cesiumViewer, 
    cabecera, 
    pie, 
    menuLateral
  },

}
</script>



// WEBPACK FOOTER //
// src/components/aplicacion.vue